var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-user',{attrs:{"editable":_vm.editable,"adm_id":_vm.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }